module.exports = __webpack_public_path__ + "static/img/15.d5460c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/winter/gift/15.png
// module id = kJ/m
// module chunks = 2